import React, { useState, useEffect } from "react";

const DesignationForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors: apiErrors = {},
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [localErrors, setLocalErrors] = useState({});

  useEffect(() => {
    if (apiErrors && Object.keys(apiErrors).length > 0) {
      setLocalErrors(apiErrors);
    }
  }, [apiErrors]);

  const validateField = (name, value) => {
    let error = "";
    if (!value || value.trim() === "") {
      error = `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    } else if (name === "name" && value.length > 50) {
      error = "Name cannot exceed 50 characters";
    } else if (name === "description" && value.length > 300) {
      error = "Description cannot exceed 300 characters";
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value);
    setLocalErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const nameError = validateField("name", formData.name);
    const descError = validateField("description", formData.description);

    if (nameError || descError) {
      setLocalErrors({ name: nameError, description: descError });
      return;
    }

    const submissionData = new FormData();
    submissionData.append("name", formData.name);
    submissionData.append("description", formData.description);
    onSubmit(submissionData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 font-poppins">
      <div>
        <label htmlFor="name" className="block dark:text-white text-sm font-medium text-gray-700">
          Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            localErrors.name ? "border-red-500" : "border-gray-300"
          }`}
        />
        {localErrors.name && <p className="text-red-500 text-sm mt-1">{localErrors.name}</p>}
      </div>

      <div>
        <label htmlFor="description" className="block dark:text-white text-sm font-medium text-gray-700">
          Description <span className="text-red-500">*</span>
        </label>
        <textarea
          id="description"
          name="description"
          rows="4"
          value={formData.description}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            localErrors.description ? "border-red-500" : "border-gray-300"
          }`}
        />
        {localErrors.description && <p className="text-red-500 text-sm mt-1">{localErrors.description}</p>}
      </div>

      <div className="flex justify-end items-center gap-2">
        <button
          type="button"
          onClick={closeModal}
          className="px-6 py-2 font-medium text-black hover:bg-gray-200 dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex items-center gap-2 px-8 py-2 font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700"
          disabled={loading || Object.values(localErrors).some(err => err)}
        >
          {initialValues.id ? "Update" : "Add"}
          {loading && (
            <svg className="animate-spin h-5 w-5 ml-2 text-white" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
          )}
        </button>
      </div>
    </form>
  );
};

export default DesignationForm;
